import gql from 'graphql-tag';
import { FULL_MOMENT_FRAGMENT } from 'graphql/fragment/momentFragment';
import { WORLD_MAP_VIEW_NO_MARKERS_FRAGMENT } from 'graphql/fragment/worldFragment';

export const G_EXTERNAL_LINK = gql`
    fragment GExternalLink on GuideExternalLink {
        guideExternalLinkId
        title
        url
    }
`;

export const EVENT_FORM_FRAGMENT = gql`
    fragment EEventForm on EventForm {
        eventFormId
        title
        thankYouMessage
        allowSubmitMultiple
        fields {
            fieldId
            title
            text
            placeholder
            type
            validation {
                required
                maxLength
            }
            options {
                optionId
                title
            }
        }
    }
`;

export const G_PROGRAM_ITEM = gql`
    fragment GProgramItem on GuideProgramItem {
        guideProgramItemId
        date
        timeStart
        timeEnd
        storyIds
        title
        description
        categories {
            worldMapSetId
        }
        loadDetailFromStoryId
        reservationSlotsCount
        reservationsCount
        room {
            worldMapMarkerId
            roomName
        }
    }
`;

export const G_INFORMATION_ITEM = gql`
    fragment GInformationItem on GuideInformationItem {
        guideInformationItemId
        storyId
    }
`;

export const G_ENTITY_TYPE = gql`
    fragment GEntityType on GuideEntityType {
        guideEntityTypeId
        name
        icon
        description
        linkUrl
        linkText
        listViewType
        sectionSetIds
        searchable
        isMapEntity
        storyIds
    }
`;

export const G_STORY_FRAGMENT = gql`
    fragment GStory on PublishedStory {
        storyId
        ...FFullMoment
        categories {
            worldMapSetId
        }
    }
    ${FULL_MOMENT_FRAGMENT}
`;

export const G_NEWSFEED_ITEM_FRAGMENT = gql`
    fragment GNewsfeedItem on GuideNewsfeedItem {
        guideNewsfeedItemId
        title
        description
        notificationsSent
        createdAt
        updatedAt
    }
`;

export const G_EXTERNAL_POINT_FRAGMENT = gql`
    fragment GExternalPoint on ExternalPoint {
        externalPointId
        title
        description
        previewImageUrl
        imageUrl
        categories {
            worldMapSetId
        }
    }
`;

export const G_NAVIGATION_ROW_FRAGMENT = gql`
    fragment GNavigationRow on GuideNavigationRow {
        navigationRowId
        type
        referenceId
        highlighted
        showDynamicNumber
        titleOverride
        iconOverride
        url
    }
`;

export const GUIDE_FRAGMENT = gql`
    fragment GGuide on Guide {
        guideId
        title
        customPath
        guideType
        logoUrl
        headerImageUrl
        styleColors {
            colorId
            value
        }
        visualStyleId
        dateTimeStart
        dateTimeEnd
        welcomeMessage
        metaTitle
        metaImageUrl
        metaDescription
        worldMapId
        entitiesEnabled
        programEnabled
        infoEnabled
        availableLanguages
        programExtensionHours
        worldMapEnabled
        worldMapPreviewUrl
        language
        newsfeedItems {
            ...GNewsfeedItem
        }
        forms {
            ...EEventForm
        }
        scannableStoryIds
        roomOrderIds
        rooms {
            worldMapMarkerId
            roomName
        }
        externalLinks {
            ...GExternalLink
        }
        stories {
            storyId
            ...GStory
        }
        categories {
            worldMapSetId
            orderIndex
            title
            color
            imageUrl
        }
        entityTypes {
            ...GEntityType
        }
        informationItems {
            ...GInformationItem
        }
        programItems {
            ...GProgramItem
        }
        externalPoints {
            ...GExternalPoint
        }
        navigation {
            drawer {
                ...GNavigationRow
            }
            tabs {
                ...GNavigationRow
            }
            homepagePrimaryModule {
                ...GNavigationRow
            }
        }
    }

    ${G_EXTERNAL_LINK}
    ${G_ENTITY_TYPE}
    ${G_INFORMATION_ITEM}
    ${G_PROGRAM_ITEM}
    ${G_STORY_FRAGMENT}
    ${EVENT_FORM_FRAGMENT}
    ${G_NEWSFEED_ITEM_FRAGMENT}
    ${G_EXTERNAL_POINT_FRAGMENT}
    ${G_NAVIGATION_ROW_FRAGMENT}
`;

export const GUIDE_VIEW_FRAGMENT = gql`
    fragment GGuideView on GuideView {
        guideId
        title
        guideType
        customPath
        logoUrl
        headerImageUrl
        styleColors {
            colorId
            value
        }
        visualStyleId
        dateTimeStart
        dateTimeEnd
        welcomeMessage
        worldMapId
        entitiesEnabled
        programEnabled
        infoEnabled
        availableLanguages
        programExtensionHours
        worldMapEnabled
        worldMapPreviewUrl
        language
        forms {
            ...EEventForm
        }
        scannableStoryIds
        roomOrderIds
        rooms {
            worldMapMarkerId
            roomName
        }
        externalLinks {
            ...GExternalLink
        }
        stories {
            storyId
            ...GStory
        }
        categories {
            worldMapSetId
            title
        }
        entityTypes {
            ...GEntityType
        }
        informationItems {
            ...GInformationItem
        }
        programItems {
            ...GProgramItem
        }
        navigation {
            drawer {
                ...GNavigationRow
            }
            tabs {
                ...GNavigationRow
            }
            homepagePrimaryModule {
                ...GNavigationRow
            }
        }
        worldMap {
            ...FWorldMapViewNoMarkers
            worldMapSets {
                title
                type
                isVisibleOnLoad
                orderIndex
                color
                imageUrl
                worldMapSetId
                markers {
                    worldMapMarkerId
                }
            }
        }
    }

    ${G_EXTERNAL_LINK}
    ${G_ENTITY_TYPE}
    ${G_INFORMATION_ITEM}
    ${G_PROGRAM_ITEM}
    ${G_STORY_FRAGMENT}
    ${WORLD_MAP_VIEW_NO_MARKERS_FRAGMENT}
    ${EVENT_FORM_FRAGMENT}
    ${G_NAVIGATION_ROW_FRAGMENT}
`;
